import { Link } from 'react-router'
import { RiArrowRightLine } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import { useInView } from '@/hooks'
import aboutImage from '@/assets/images/home page (about Simone new).png'

export const AboutSection = () => {
  const { ref: imageRef, inView: imageInView } = useInView<HTMLDivElement>()
  const { ref: textRef, inView: textInView } = useInView<HTMLDivElement>()

  return (
    <section className="bg-white py-20 lg:py-28 overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
          {/* ── Image ── */}
          <div
            ref={imageRef}
            className={`w-full lg:w-[42%] shrink-0 ${imageInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          >
            <div className="relative mx-auto max-w-[340px] lg:max-w-none">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-crimson-50 shadow-[0_24px_60px_rgba(155,28,28,0.1)]">
                <img
                  src={aboutImage}
                  alt="Simone — founder of H.E.R Birth Keeper"
                  loading="lazy"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* 15+ badge */}
              <div
                className={`absolute -bottom-5 -right-4 lg:-right-6 bg-white rounded-2xl px-5 py-4 shadow-[0_8px_32px_rgba(155,28,28,0.13)] ${imageInView ? 'animate-fade-in-up' : 'opacity-0'}`}
                style={{ animationDelay: imageInView ? '0.3s' : undefined }}
              >
                <p className="font-display text-3xl font-bold text-gold-500 leading-none">15+</p>
                <p className="text-xs text-base-500 font-medium mt-1 whitespace-nowrap">
                  Years Advocacy Experience
                </p>
              </div>

              <div
                aria-hidden="true"
                className="absolute -top-5 -left-5 w-28 h-28 rounded-full border-2 border-gold-300 opacity-50"
              />
              <div
                aria-hidden="true"
                className="absolute -top-2 -left-2 w-16 h-16 rounded-full border border-gold-200 opacity-40"
              />
            </div>
          </div>

          {/* ── Text ── */}
          <div ref={textRef} className="flex-1 space-y-6 text-center lg:text-left">
            <div className={textInView ? 'animate-fade-in-up' : 'opacity-0'}>
              <h2
                className="font-display font-bold text-base-900 leading-tight mb-3"
                style={{ fontSize: 'clamp(2rem, 4.5vw, 3.25rem)' }}
              >
                Your Antenatal and{' '}
                <em className="text-crimson-600 not-italic">Postpartum Birthkeeper</em> By Your Side
              </h2>
              <p className="font-display italic text-base-600 text-lg lg:text-xl leading-relaxed">
                Bringing a calm, patient, and compassionate presence on your journey
              </p>
            </div>

            <div
              className={`w-12 h-[3px] rounded-full bg-gradient-to-r from-crimson-600 to-gold-500 mx-auto lg:mx-0 ${textInView ? 'animate-fade-in' : 'opacity-0'}`}
              style={{ animationDelay: textInView ? '0.15s' : undefined }}
            />

            <p
              className={`text-[15px] text-base-600 leading-[1.85] max-w-lg mx-auto lg:mx-0 ${textInView ? 'animate-fade-in-up' : 'opacity-0'}`}
              style={{ animationDelay: textInView ? '0.2s' : undefined }}
            >
              Simone is a passionate advocate and the founder of H.E.R Birth Keeper, bringing over
              15 years of experience within the VAWG sector. As a mother of two, her lived
              experience as a Black woman navigating pregnancy and motherhood shapes every aspect of
              her care.
            </p>

            <div
              className={`flex justify-center lg:justify-start pt-2 ${textInView ? 'animate-fade-in-up' : 'opacity-0'}`}
              style={{ animationDelay: textInView ? '0.3s' : undefined }}
            >
              <Link to={ROUTES.ABOUT} className="btn-outline">
                Meet Simone
                <RiArrowRightLine size={17} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
